import React from 'react';
import type { DraggedLayout } from '../plugin/types';

import styles from './StripedArea.scss';

interface StripedAreaProps {
  x: number;
  y: number;
  width: number;
  height: number;
  draggedComponents: DraggedLayout[];
  stripeWidth?: number;
}

const getTransform = (comp: DraggedLayout) => {
  return `rotate(${comp.rotationInDegrees}, ${comp.x + comp.width / 2}, ${
    comp.y + comp.height / 2
  })`;
};

export const StripedArea: React.FC<StripedAreaProps> = ({
  x,
  y,
  width,
  height,
  draggedComponents,
  stripeWidth = 4,
}) => {
  const patternId = `stripedPattern-${x}-${y}`;
  const maskId = `mask-${x}-${y}`;

  const relativeDraggedComponents = draggedComponents.map((island) => ({
    ...island,
    x: island.x - x,
    y: island.y - y,
  }));

  const svgRect = {
    x,
    y,
    width,
    height,
    style: {
      left: x,
      top: y,
    },
  };

  return (
    <svg className={styles.stripedArea} {...svgRect}>
      <defs>
        <pattern
          id={patternId}
          width={stripeWidth * 2}
          height={stripeWidth * 2}
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(45)"
        >
          <rect
            width={stripeWidth}
            height={stripeWidth * 2}
            className={styles.stripeSvgRect}
          />
          <rect
            x={stripeWidth}
            width={stripeWidth}
            height={stripeWidth * 2}
            fill="white"
          />
        </pattern>
        <mask id={maskId}>
          <rect width={width} height={height} fill="white" />
          {relativeDraggedComponents.map((comp, index) => (
            <rect
              key={index}
              x={comp.x}
              y={comp.y}
              width={comp.width}
              height={comp.height}
              fill="black"
              transform={getTransform(comp)}
            />
          ))}
        </mask>
      </defs>
      <rect
        x={0}
        y={0}
        width={width}
        height={height}
        opacity={0.5}
        mask={`url(#${maskId})`}
        fill={`url(#${patternId})`}
      />
    </svg>
  );
};
